<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <h1 v-on:click="signout()">SignOut</h1> -->

    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <home-header></home-header>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- 底部导航栏 -->
    <div class="bottom-tabs">
      <span style="cursor: pointer; text-align: center; text-decoration: underline" v-on:click="tncClick">
        {{ $t('footer.termsOfUse') }}
      </span>
      <span style="text-align: center; margin: 5px 0 0 0"
        >{{ $t('footer.copyRightPrefix') }}{{ year }}{{ $t('footer.copyRightSurfix') }}</span
      >
    </div>
  </div>
</template>

<script>
import HomeHeader from './views/header/header';

export default {
  name: 'App',
  data() {
    return {
      year: '2021'
    };
  },
  components: { HomeHeader },
  methods: {
    tncClick() {
      window.open(this.$t('footer.termsOfUseLink'));
    }
  },
  created: function () {
    this.year = this.$moment().format('YYYY');
  }
};
</script>

<style>
#app {
  height: 100%;
  /* border: 1px solid #f1f3f4; */
}

.bottom-tabs {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  display: grid;
  justify-content: space-around;
  align-items: center;
  height: 40px;
  margin-bottom: 5px;
}
</style>
